import { render, staticRenderFns } from "./BoD.vue?vue&type=template&id=1c70a59f&scoped=true&"
import script from "./BoD.vue?vue&type=script&lang=js&"
export * from "./BoD.vue?vue&type=script&lang=js&"
import style0 from "./BoD.vue?vue&type=style&index=0&id=1c70a59f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70a59f",
  null
  
)

export default component.exports